import type { ExtendedObservation } from '@seen/core/models/observation'
import type { JSX } from 'react'
import { ResourceFieldForm } from '#src/components/core/form/ResourceFieldForm.tsx'
import { ObservationRichTextEditor } from '#src/components/rich-text-editor/ObservationNode/ObservationRichTextEditor.tsx'
import { useCurrentPractitioner } from '#src/hooks/useCurrentPractitioner.ts'

export function ObservationNoteFieldForm({
  observation,
  className,
}: {
  observation: ExtendedObservation
  className?: string
}): JSX.Element {
  const practitioner = useCurrentPractitioner()
  return (
    <ResourceFieldForm
      instance={observation}
      valueFn={(o) => o.noteFirstText}
      patchFn={(o, v) => {
        o.setNoteFirst(v ?? undefined, practitioner.reference)
        o.performerPractitioner = practitioner.reference
      }}
      debounceTyping
      render={({ field }) => (
        <ObservationRichTextEditor placeholder="Notes…" {...field} />
      )}
      className={className}
    />
  )
}
